<div class="linkedin-templates">
    <div class="linkedin-card" *ngFor="let linkedin of generatedLinkedins; let i = index">
        <img [src]="getImageUrl(linkedin.imagePath)" alt="{{ 'common.linkedInTemplate' | translate }} {{ i + 1 }}"
            (contextmenu)="disableRightClick($event)" />

        <div class="buttons">

            <!-- If paid and PDF exists -->
            <button *ngIf="linkedin.isPaid && linkedin.pdfPath; else notPaid" class="pdf_download"
                (click)="downloadFile(linkedin.pdfPath!)">
                {{ "Download PDF" | translate }}
            </button>

            <!-- Else not paid -->
            <ng-template #notPaid>
                <button class="pdf_download" (click)="makeOrder(linkedin.id, 'enhance-linkedin')">
                    {{ "Buy" | translate }}
                </button>
            </ng-template>

        </div>
    </div>
</div>